import { motion } from 'framer-motion';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: '田中花子様',
      age: '82歳',
      location: '岡山市北区在住',
      image: 'https://public.readdy.ai/ai/img_res/108329de6339290347a274f1fb8ad6ce.jpg',
      comment: '一人暮らしで不安でしたが、スタッフの皆さんが親身になってサポートしてくださり、毎日安心して過ごせています。本当に感謝しています。',
      rating: 5,
    },
    {
      name: '山田太郎様のご家族',
      age: '父親88歳',
      location: '岡山市北区在住',
      image: 'https://readdy.ai/api/search-image?query=middle%20aged%20japanese%20woman%20smiling%20warmly%20at%20home%20natural%20daylight%20caring%20expression%20indoor%20setting%20simple%20clean%20background%20portrait&width=400&height=400&seq=testimonial-2&orientation=squarish',
      comment: '遠方に住んでいるため、父の介護に不安がありましたが、定期的な報告と丁寧なケアで安心してお任せできています。',
      rating: 5,
    },
    {
      name: '佐藤良子様',
      age: '76歳',
      location: '岡山市北区在住',
      image: 'https://readdy.ai/api/search-image?query=cheerful%20elderly%20japanese%20woman%20in%20her%2070s%20at%20home%20bright%20natural%20light%20happy%20expression%20comfortable%20living%20space%20simple%20background%20portrait&width=400&height=400&seq=testimonial-3&orientation=squarish',
      comment: '身体が不自由になってからも、自宅で快適に暮らせるのはヘルパーさんのおかげです。いつも明るく接してくださり、心が温かくなります。',
      rating: 5,
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-beige-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-16"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-800 mb-3 sm:mb-4 px-4">
            お客様の声
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-navy-700 max-w-2xl mx-auto px-4">
            岡山市北区の皆様からたくさんの喜びの声をいただいています
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-6 sm:p-8 shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="flex items-center mb-4 sm:mb-6">
                <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full overflow-hidden mr-4 flex-shrink-0">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base sm:text-lg font-bold text-navy-800 truncate">
                    {testimonial.name}
                  </h3>
                  <p className="text-xs sm:text-sm text-navy-600">
                    {testimonial.age} / {testimonial.location}
                  </p>
                </div>
              </div>

              <div className="flex mb-3 sm:mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-base sm:text-lg text-coral-500"></i>
                ))}
              </div>

              <p className="text-sm sm:text-base text-navy-700 leading-relaxed">
                {testimonial.comment}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
